import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import H6 from '@base/H6/H6';
import P1 from '@base/P1/P1';
import Image from '@base/Image';
import { Spacings } from '@styles/index';
import Paper from '@base/Paper/Paper';
import ChevronRight from '@icon/ChevronRight';

const FileIcon = 'quiz/file-empty.svg';

const AttemptCard = styled(Paper)`
  padding: ${Spacings.SPACING_6B} 0;
  margin: ${Spacings.SPACING_6B} 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: ${({ $isClickable }) => ($isClickable ? 'pointer' : 'inherit')};
`;

const SubText = styled(P1)`
  color: var(--color-text-secondary);
`;

const IconWrapper = styled(Paper)`
  background-color: var(--color-i-gray-v2);
  width: 40px;
  height: 40px;
  padding: 0;
  display: grid;
  place-items: center;
  margin-left: ${Spacings.SPACING_8B};
  border-radius: 50%;
`;

const TextWrapper = styled.div`
  padding-left: ${Spacings.SPACING_4B};
  padding-right: ${Spacings.SPACING_4B};
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const GoIcon = styled.div`
  padding-right: ${Spacings.SPACING_8B};
`;

const InfoWrapper = styled.div`
  display: flex;
`;

const InfoCard = ({ title, subText, onClick }) => (
  <AttemptCard $isClickable={!!onClick} onClick={onClick}>
    <InfoWrapper>
      <IconWrapper>
        <Image width={25} height={25} src={FileIcon} alt="file" />
      </IconWrapper>
      <TextWrapper>
        <H6>{title}</H6>
        {subText && <SubText>{subText}</SubText>}
      </TextWrapper>
    </InfoWrapper>

    {onClick && (
      <GoIcon>
        <ChevronRight size="25px" />
      </GoIcon>
    )}
  </AttemptCard>
);

export default InfoCard;

InfoCard.propTypes = {
  title: PropTypes.string.isRequired,
  subText: PropTypes.string,
  onClick: PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.func])
};

InfoCard.defaultProps = {
  subText: '',
  onClick: null
};
